<template>
  <v-form v-model="valid" ref="psychStepFourForm">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.aboutInfo"
              )
            }}
            <br />
            <span class="font-gotham text-gray">
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepFour.warning"
                )
              }}</span
            >
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            auto-grow
            v-model="personalInfo.uk"
            solo
            name="input-7-4"
            rows="2"
            :counter="2000"
            :rules="[...textAreaValidationRules, noRussianRule]"
            @input="saveDebounced"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="5">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.notWorkingWith"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <v-textarea
            v-model="notWorkingWith"
            solo
            name="input-7-4"
            rows="2"
            :counter="10"
            :rules="[...entrepreneurRules, noRussianRule]"
            @input="saveDebounced"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col cols="12" md="5">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.infoChannel"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <v-select
            v-model="howFound"
            :items="howFoundItems"
            solo
            :rules="[(v) => !!v || 'Оберіть варіант']"
            :menu-props="{ offsetY: true }"
            @change="saveDebounced"
          ></v-select>
          <v-textarea
            v-model="informationChanel"
            solo
            name="input-7-4"
            rows="2"
            placeholder="Уточніть, якщо хочете (наприклад, хто порекомендував)"
            :rules="[noRussianRule]"
            @input="saveDebounced"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col cols="12" md="5">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.clientsQuantity"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="3" offset-md="1">
          <v-text-field
            v-model="numberOfClientsReadyToServe.from"
            :rules="numberOfClientsReadyToServeRules"
            :label="
              $vuetify.lang.t(`$vuetify.main.psychologistReg.stepFour.from`)
            "
            required
            class="mt-0 pt-0"
            @input="saveDebounced"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="numberOfClientsReadyToServe.to"
            :rules="numberOfClientsReadyToServeRules"
            :label="
              $vuetify.lang.t(`$vuetify.main.psychologistReg.stepFour.to`)
            "
            required
            class="mt-0 pt-0"
            @input="saveDebounced"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col cols="12" md="5">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.mediaLinksTitle"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <v-textarea
            required
            v-model="socialMediaLinks"
            solo
            name="input-7-4"
            rows="3"
            :rules="socialMediaLinksRules"
            @input="saveDebounced"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col cols="12" md="5">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.settings.video"
              )
            }}
          </p>
          <p class="caption grey--text text--darken-1 mt-n2">
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.settings.videoOptional"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <!-- <v-textarea
            v-model="psyhVideo"
            solo
            name="input-7-4"
            rows="1"
            @input="saveDebounced"
          ></v-textarea> -->

          <v-text-field
            v-model="psyhVideo"
            :label="
              $vuetify.lang.t(
                `$vuetify.main.psychologistDashboard.settings.videoLabel`
              )
            "
            @input="saveDebounced"
            outlined
            :hint="$vuetify.lang.t('$vuetify.main.psychologistDashboard.settings.videoHint')"
            persistent-hint
            class="mt-3"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="pb-6 mt-0">
        <v-col cols="12" md="5">
          <p class="mb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.stepFour.photoTitle"
              )
            }}
          </p>
          <v-file-input
            :rules="photosRules"
            v-model="photos"
            accept="image/png, image/jpeg, image/bmp, image/webp, image/gif, image/jpg"
            show-size
            counter
            multiple
            :label="
              $vuetify.lang.t(
                `$vuetify.main.psychologistReg.stepFour.photoLabel`
              )
            "
            class="pt-7"
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <span>{{
            $vuetify.lang.t(
              "$vuetify.main.psychologistReg.stepFour.requirements"
            )
          }}</span>
          <ul>
            <li>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepFour.requirements1"
                )
              }}
            </li>
            <li>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepFour.requirements2"
                )
              }}
            </li>
            <li>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepFour.requirements3"
                )
              }}
            </li>
            <li>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepFour.requirements4"
                )
              }}
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from '@/utils/debounce'
import { noRussianRule } from "@/utils/noRussian";

export default {
  name: "stepFour",
  data() {
    return {
      saveDebounced: function() {},
      valid: false,
      personalInfo: { uk: "", ru: "" },
      notWorkingWith: "",
      informationChanel: "",
      howFound: null,
      howFoundItems: [
        { value: "google", text: "Google" },
        { value: "instagram", text: "Instagram" },
        { value: "facebook", text: "Facebook" },
        { value: "ads", text: "Реклама" },
        { value: "recommendation", text: "Рекомендація" },
        { value: "other", text: "Інше" },
      ],
      psyhVideo: "",
      photos: [],
      photosRules: [(value) => value.length > 0 || value.size < 2000000],
      numberOfClientsReadyToServe: {
        from: "",
        to: "",
      },
      socialMediaLinks: "",
      socialMediaLinksRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepFour.rules"),
        (v) =>
          v.length >= 10 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepFour.socialMediaLinksMin50"
          ),
        (v) =>
          v.length <= 2000 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepFour.socialMediaLinks2k"
          ),
      ],
      entrepreneurRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepFour.rules"),
        (v) =>
          v.length >= 10 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepFour.entrepreneurRules"
          ),
      ],
      textAreaValidationRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepFour.rules"),
        (v) =>
          v.length >= 50 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepFour.textAreaValidationRulesMin50"
          ),
        (v) =>
          v.length <= 2000 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepFour.textAreaValidationRules"
          ),
      ],
      numberOfClientsReadyToServeRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepFour.rules"),
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  watch: {
    valid() {
      this.$emit("handle-valid", this.valid);
    },
  },
  created() {
    this.$eventHub.$on("psych-step-four-form_validate-form", this.validate);
    this.loadUser();
    this.saveDebounced = debounce(() => {
      this.saveData();
    }, 400)
  },
  mounted() {
    this.$emit("handle-valid", this.valid);
  },
  beforeDestroy() {
    this.$eventHub.$off("psych-step-four-form_validate-form", this.validate);
    this.saveDebounced.cancel();
  },
  methods: {
    noRussianRule,
    loadUser() {
      if (this.user.psychologistQuestionnaire.profile.video_source_url) {
        this.psyhVideo = this.user.psychologistQuestionnaire.profile.video_source_url;
      } 
      if (this.user.psychologistQuestionnaire.profile.about_info?.ru) {
        this.personalInfo.ru = this.user.psychologistQuestionnaire.profile.about_info?.ru;
      } 
      if (this.user.psychologistQuestionnaire.profile.about_info?.uk) {
        this.personalInfo.uk = this.user.psychologistQuestionnaire.profile.about_info?.uk;
      } 
      if (this.user.psychologistQuestionnaire.profile.about_do_not_work_with) {
        this.notWorkingWith = this.user.psychologistQuestionnaire.profile.about_do_not_work_with;
      } 
      if (this.user.psychologistQuestionnaire.profile.about_min_patients) {
        this.numberOfClientsReadyToServe.from = this.user.psychologistQuestionnaire.profile.about_min_patients;
      }
      if (this.user.psychologistQuestionnaire.profile.about_max_patients) {
        this.numberOfClientsReadyToServe.to = this.user.psychologistQuestionnaire.profile.about_max_patients;
      }
      if (this.user.psychologistQuestionnaire.profile.about_social_media_links) {
        this.socialMediaLinks = this.user.psychologistQuestionnaire.profile.about_social_media_links;
      }
      if (this.user.psychologistQuestionnaire.profile.how_found) {
        this.howFound = this.user.psychologistQuestionnaire.profile.how_found;
      }
      if (this.user.psychologistQuestionnaire.profile.about_how_found_platform) {
        this.informationChanel = this.user.psychologistQuestionnaire.profile.about_how_found_platform;
      }
    },
    saveData() {
      this.$store.dispatch("user/setQuestionnaireProfile", {
        video_source_url: this.psyhVideo,
        about_info: { ru: this.personalInfo.uk, uk: this.personalInfo.uk },
        about_do_not_work_with: this.notWorkingWith,
        about_min_patients: this.numberOfClientsReadyToServe.from,
        about_max_patients: this.numberOfClientsReadyToServe.to,
        about_social_media_links: this.socialMediaLinks,
        about_how_found_platform: this.informationChanel,
        how_found: this.howFound,
      });
    },
    validate() {
      this.$refs.psychStepFourForm.validate();

      this.saveData();
      
      this.$store.dispatch("user/setUserPhoto", this.photos[0]);
    },
  },
};
</script>
